import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthState } from '@/lib/auth/hooks/useAuthState.ts';
import { PaymentMethod } from '@/lib/payment-methods/payment-method.ts';
import {
  getPaymentMethods,
  deletePaymentMethod as deletePaymentMethodFn,
} from '@/lib/payment-methods';
import { toast } from 'sonner';

export function usePaymentMethods() {
  const queryClient = useQueryClient();
  const { isAuthenticated, accessToken } = useAuthState();

  const {
    data: paymentMethods,
    isPending,
    isFetched,
  } = useQuery<PaymentMethod[]>({
    queryKey: ['payment-methods'],
    queryFn: getPaymentMethods,
    enabled: isAuthenticated && !!accessToken,
  });

  const invalidate = async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ['payment-methods'] }),
      queryClient.invalidateQueries({ queryKey: ['me'] }),
    ]);
  };

  const { mutateAsync: deletePaymentMethod, isPending: isDeleting } =
    useMutation({
      mutationFn: deletePaymentMethodFn,
      onSuccess: async () => {
        toast.success('Tarjeta eliminada correctamente');
        await invalidate();
      },
      onError: () => {
        toast.error('No se pudo eliminar la tarjeta. Intenta nuevamente.');
      },
    });

  return {
    paymentMethods: paymentMethods ?? [],
    isLoading: isAuthenticated && !!accessToken && isPending,
    isFetched,
    deletePaymentMethod,
    isDeleting,
  };
}
